import {useState} from 'react';
import Cookies from "js-cookie";
import {doAuthSSO} from "../api/client";

export function useNebulaAuth() {

  const [state, setState] = useState({
    busy: false,
  })

  const authSSO = async (email, idToken, instanceUrl, module) => {

    setState({
      busy: true,
    })

    Cookies.remove('hti-session')

    return await doAuthSSO(email, idToken, instanceUrl, module)
    .finally(() => {
      setState({
        busy: false,
      })
    });
  }

  return {
    authSSO,
    ...state
  }

}